// Mutuals show "Ignore fee" (fee applies unless ticked) instead of "Apply Fee" (#36240).
export const usesIgnoreFeeCheckbox = (brandAppConfig) => brandAppConfig?.reinstatementIgnoreFeeCheckbox === true;
